import { apiFetch } from "./api";

interface UploadArgs {
  clientId: string; file: File; docType: string;
  expirationDate?: string; licenseNumber?: string; licenseState?: string;
}

/** Full document upload: presign → browser PUT to S3 → confirm (persists the Document record). */
export async function uploadDocument(token: string | null, a: UploadArgs) {
  const presign = await apiFetch<{ docId: string; key: string; uploadUrl: string }>(
    "/documents/presign-upload",
    { method: "POST", token, body: JSON.stringify({ clientId: a.clientId, fileName: a.file.name, mimeType: a.file.type, sizeBytes: a.file.size }) },
  );
  const put = await fetch(presign.uploadUrl, { method: "PUT", headers: { "content-type": a.file.type }, body: a.file });
  if (!put.ok) throw new Error(`Upload failed (${put.status}).`);
  return apiFetch("/documents/confirm", {
    method: "POST", token,
    body: JSON.stringify({
      clientId: a.clientId, docId: presign.docId, key: presign.key, docType: a.docType,
      fileName: a.file.name, mimeType: a.file.type, sizeBytes: a.file.size,
      expirationDate: a.expirationDate || undefined,
      licenseNumber: a.licenseNumber || undefined, licenseState: a.licenseState || undefined,
    }),
  });
}
